import { useState, useEffect } from 'react';
import api from '../utils/api';
import { useLanguage } from '../context/LanguageContext';

/**
 * useFooterLegalLinks — canonical public footer legal documents.
 *
 * LEGAL-PUBLIC-FOOTER-PROCESS-01. Reads the SSOT endpoint
 * GET /api/public/legal/footer?language=, whose membership derives from
 * the active `public_legal_footer` process binding intersected with
 * canonical published+active document state. Presentation only — no
 * consent, no enforcement. Empty until an Admin assigns documents.
 */
export function useFooterLegalLinks() {
  const { language } = useLanguage();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const { data } = await api.get(`/public/legal/footer?language=${encodeURIComponent(language || 'en')}`);
        if (!cancelled) setItems(Array.isArray(data?.items) ? data.items : []);
      } catch {
        if (!cancelled) setItems([]); // fail-closed: show no legal docs
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [language]);

  return { items, loading };
}
